import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a585649e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sms-packages-summary" }
const _hoisted_2 = { class: "summary-item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total SMS Count:", -1))
const _hoisted_4 = { class: "summary-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total Usage:", -1))
const _hoisted_6 = { class: "summary-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total Remaining SMS:", -1))
const _hoisted_8 = { class: "summary-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Active Packages Count:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.dialogVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    style: { width: '600px' },
    header: "SMS Packages",
    modal: true,
    closable: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("strong", null, _toDisplayString(_ctx.totalSMSCount), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("strong", null, _toDisplayString(_ctx.totalUsage), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("strong", null, _toDisplayString(_ctx.totalRemainingSMS), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("strong", null, _toDisplayString(_ctx.activePackagesCount), 1)
        ])
      ]),
      _createVNode(_component_DataTable, {
        value: _ctx.smsPackages,
        responsiveLayout: "scroll",
        class: "p-datatable-sm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "package_id",
            header: "Package ID"
          }),
          _createVNode(_component_Column, {
            field: "sms_count",
            header: "SMS Count"
          }),
          _createVNode(_component_Column, {
            field: "usage",
            header: "Usage"
          }),
          _createVNode(_component_Column, {
            field: "activated_date",
            header: "Activated Date"
          }),
          _createVNode(_component_Column, {
            field: "status",
            header: "Status"
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }, 8, ["visible"]))
}